<template>
  <p class="captionText">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'CaptionText',
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.captionText {
  color: $color-text-secondry;
  font-size: $text-size-caption1;
  line-height: 1.5;

  ul {
    li {
      list-style-type: disc;
      margin-left: 18px;
      text-align: left;
    }
  }
}
</style>
